/* eslint-disable no-debugger */
import { filter as _filter } from "lodash";
import * as types from "../types";

export const updateQuestionAnswer = ({ id, questionAnswer }) => ({
  type: types.UPDATE_QUESTION_ANSWER,
  request: {
    url: `/question_answers/${id}`,
    method: "PATCH",
    data: {
      questionAnswer
    }
  },
  meta: {
    mutations: {
      [types.GET_EPOSTER_QAS]: (prevData, newData) => {
        return {
          ...prevData,
          data: [..._filter(prevData.data, x => x.id !== newData.data.id), newData.data]
        };
      },
      [types.GET_MODULE_QAS]: (prevData, newData) => {
        return {
          ...prevData,
          data: [..._filter(prevData.data, x => x.id !== id), newData.data]
        };
      },
      [types.GET_PROFILE_QAS]: (prevData, newData) => {
        return {
          ...prevData,
          data: [..._filter(prevData.data, x => x.id !== id), newData.data]
        };
      }
    }
  }
});

export const deleteQuestionAnswer = ({ id }) => ({
  type: types.DELETE_QUESTION_ANSWER,
  request: {
    url: `/question_answers/${id}`,
    method: "DELETE"
  },
  meta: {
    mutations: {
      [types.GET_EPOSTER_QAS]: prevData => {
        return {
          ...prevData,
          data: [..._filter(prevData.data, x => x.id !== id)]
        };
      },
      [types.GET_MODULE_QAS]: prevData => {
        return {
          ...prevData,
          data: [..._filter(prevData.data, x => x.id !== id)]
        };
      },
      [types.GET_PROFILE_QAS]: prevData => {
        return {
          ...prevData,
          data: [..._filter(prevData.data, x => x.id !== id)]
        };
      }
    }
  }
});
